import { useState, useEffect } from 'react';

// Validators
import { FormsValidator } from '../validators';

export const useValidatorFormDocument = (pageConfig, document) => {    
  
    const inputs = {

        document: 'document'
    };

    const [validation, setValidation] = useState({ summary: null, formValid: false, formComplete: false });

    useEffect(() => {

        const validations = FormsValidator.summary([
            () => FormsValidator.required(pageConfig, document, inputs.document),
            () => FormsValidator.min(pageConfig, document, inputs.document),
            () => FormsValidator.max(pageConfig, document, inputs.document)
        ]);
        
        setValidation({
            summary: validations.filter(v => !v.valid),
            formValid: validations.formValid,
            formComplete: document >= pageConfig.rules.inputs.document.min.value && document <= pageConfig.rules.inputs.document.max.value
        });

    }, [document]);

    return { validation, inputs };
};